import {Instancesmanager} from 'asteq.instancesmanager';

class Resolving {
    constructor(key, resolveFunction, rejectFunction) {
        this.key = key;
        this.resolveFunction = resolveFunction;
        this.rejectFunction = rejectFunction;
    }

    resolve(instance) {
        if (!this.resolveFunction) {
            return;
        }

        this.resolveFunction(instance);
    }
}

class ResolvingsPool {
    constructor(key) {
        this.key = key;
        this.resolvings = [];
    }

    add(resolving) {
        this.resolvings.push(resolving);
    }

    resolve(instance) {
        this.resolvings.forEach((resolving) => {
            resolving.resolve(instance);
        });
        this.resolvings = [];
    }
}

export class InstancesManagerAsync extends Instancesmanager {
    constructor() {
        super();
        this.pools = {};
    }

    async getInstanceAsync(key) {
        return new Promise((resolve, reject) => {
            const instance = this.getInstance(key);
            if (instance) {
                resolve(instance);
                return;
            }

            let pool = this.pools[key];
            if (!pool) {
                pool = new ResolvingsPool(key);
                this.pools[key] = pool;
            }

            pool.add(new Resolving(key, resolve, reject));
        });
    }

    addInstance(key, instance) {
        super.addInstance(key, instance);

        const pool = this.pools[key];
        if (!pool) {
            return;
        }

        pool.resolve(instance);
    }
}